import { useCallback, useContext } from "react";
import styled from "styled-components";
import {
  Flex,
  Text,
  Box,
  ViewerContext,
  Avatar,
  localStorage,
  DropDown,
} from "dash-ui";
import { useLogoutMutation } from "gql/generated.graphql";
import { useTranslation } from "react-i18next";
import noop from "lodash/noop";
import { client } from "gql/client";

const AnchorContainer = styled(Flex)`
  height: inherit;
`;
const AvatarContainer = styled(Box)<{ isOpen: boolean }>`
  border-radius: 50%;
  border: 1px solid
    ${({ isOpen, theme }) => (isOpen ? theme.colors.b50 : "transparent")};
`;

function ProfileDropdown() {
  const {
    account,
    setAccount = noop,
    setTokens = noop,
  } = useContext(ViewerContext);
  const { t } = useTranslation("common", { keyPrefix: "labels" });

  const [logout, { loading }] = useLogoutMutation();

  const onLogoutButtonClick = useCallback(async () => {
    // log out on backend
    await logout({
      onCompleted: () => {
        client.clearStore();
      },
    });

    // log out on storage
    localStorage.setAccessToken("");
    localStorage.setRefreshToken("");
    localStorage.setRefreshTokenExpiry("");

    // log out on context
    setTokens({});
    setAccount(null);
  }, [logout, setAccount, setTokens]);

  return (
    <Box mr={[4, 4, 14, 14]}>
      <DropDown
        Anchor={({ isOpen }: { isOpen: boolean }) => (
          <AnchorContainer alignItems="center">
            <Flex>
              <Text>{account?.email}</Text>
            </Flex>
            <Flex ml={4}>
              <AvatarContainer isOpen={isOpen}>
                <Avatar firstName={account?.email} />
              </AvatarContainer>
            </Flex>
          </AnchorContainer>
        )}
        items={[
          {
            key: "logout",
            icon: "logout",
            iconProps: { size: 22 },
            children: t`signOut`,
            onClick: onLogoutButtonClick,
            disabled: loading,
          },
        ]}
      />
    </Box>
  );
}

export default ProfileDropdown;
